import { FormGroup } from '@angular/forms';
import { isEqual } from 'lodash-es';
import { FormGroupRules } from '@shared/models/interfaces/form-group-rules.model';
import { addRemoveError } from '@shared/helpers/form.helper';
import { isNilOrEmpty } from '@shared/helpers/utils.helper';
import { REQUIRED_STATUS } from '@shared/constants/shared.constants';
import { altreNotCkHelper, getAltreNotControl } from './helpers/altre-not-libri-soc-form.helper';

export const altreNotLibriSocialiLibriSocialiRules: FormGroupRules = {
    my_DescVertenzeGiudiz: (form: FormGroup) => {
        altreNotCkHelper(form, 'my_DescVertenzeGiudiz', 'my_CkVertenzeGiudiz', 1);
    },

    my_CkLibriSocBolloVid: (form: FormGroup) => {
        altreNotCkHelper(form, 'my_CkLibriSocBolloVid', 'my_CkLibriSociali', 1);
    },

    my_CkLibriSocTassa: (form: FormGroup) => {
        altreNotCkHelper(form, 'my_CkLibriSocTassa', 'my_CkLibriSociali', 1);
    },

    my_NoteLibroSoci: (form: FormGroup) => {
        altreNotCkHelper(form, 'my_NoteLibroSoci', 'my_CkLibroSociDati', 0);
    },

    my_NoteLibroAssemb: (form: FormGroup) => {
        const my_NoteLibroAssembControl = getAltreNotControl(form, 'my_NoteLibroAssemb');
        const my_CkLibroAssVerb: string = getAltreNotControl(form, 'my_CkLibroAssVerb').value;
        const my_CkLibroAssRedaz: string = getAltreNotControl(form, 'my_CkLibroAssRedaz').value;
        const my_CkLibroAssVerbSott: string = getAltreNotControl(form, 'my_CkLibroAssVerbSott').value;
        const my_CkLibroAssTrascritti: string = getAltreNotControl(form, 'my_CkLibroAssTrascritti').value;
        const showError =
            isNilOrEmpty(my_NoteLibroAssembControl.value) &&
            (my_CkLibroAssVerb === '0' || my_CkLibroAssRedaz === '0' || my_CkLibroAssVerbSott === '0' || my_CkLibroAssTrascritti === '0');
        const errors = my_NoteLibroAssembControl.errors ? my_NoteLibroAssembControl.errors : {};

        addRemoveError(showError, errors, 'my_NoteLibroAssemb', {
            status: REQUIRED_STATUS,
        });

        my_NoteLibroAssembControl.setErrors(isEqual(errors, {}) ? null : errors);
    },

    my_NoteLibroOrgAmm: (form: FormGroup) => {
        altreNotCkHelper(form, 'my_NoteLibroOrgAmm', 'my_CkLibroOrgAmm', 0);
    },

    my_DescVerbConoscSoci: (form: FormGroup) => {
        altreNotCkHelper(form, 'my_DescVerbConoscSoci', 'my_CkVerbConoscSoci', 0);
    },

    my_CkLibroGioInvAgg: (form: FormGroup) => {
        altreNotCkHelper(form, 'my_CkLibroGioInvAgg', 'my_CkLibroGioInv', 1);
    },

    my_CkLibroGioInvBollo: (form: FormGroup) => {
        altreNotCkHelper(form, 'my_CkLibroGioInvBollo', 'my_CkLibroGioInv', 1);
    },

    my_CkLibroGioInvLR: (form: FormGroup) => {
        altreNotCkHelper(form, 'my_CkLibroGioInvLR', 'my_CkLibroGioInv', 1);
    },
};
